// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6718caec","685":"7200af15","866":"e4f49723"}[chunkId] + ".chunk.js";
};